// Textos del portal público en español (base) e inglés.
// Para agregar un texto: ponerlo en `es` y en `en` con la misma ruta de claves.

export interface Tramite {
  nombre: string;
  entidad: string;
  dias: number;
  opcional?: boolean;
}

const tramitesEs: Tramite[] = [
  { nombre: "Concepto de uso del suelo", entidad: "Planeación Territorial", dias: 15 },
  { nombre: "Certificado de línea de paramentos", entidad: "Planeación Territorial", dias: 15 },
  { nombre: "Cumplimiento Art. 73: sistema vial y servicios públicos", entidad: "Planeación Territorial", dias: 15 },
  { nombre: "Disponibilidad de acueducto y alcantarillado", entidad: "Veolia", dias: 45 },
  { nombre: "Disponibilidad de gas natural", entidad: "Vanti", dias: 5 },
  { nombre: "Englobe o corrección de linderos", entidad: "Gestión Catastral", dias: 32 },
  { nombre: "Licencia de urbanización y construcción", entidad: "Curaduría Urbana 2", dias: 45 },
  { nombre: "Impuesto de delineación urbana", entidad: "Hacienda Pública", dias: 1 },
  { nombre: "Licencia de intervención del espacio público", entidad: "Planeación Territorial", dias: 15 },
  { nombre: "Aprobación de propiedad horizontal", entidad: "Curaduría Urbana 2", dias: 15, opcional: true },
  { nombre: "Enajenación de inmuebles para vivienda", entidad: "Infraestructura Territorial", dias: 30 },
  { nombre: "Certificado de estratificación", entidad: "Planeación Territorial", dias: 15 },
  { nombre: "Reclamación de estratificación", entidad: "Planeación Territorial", dias: 15, opcional: true },
  { nombre: "Conexión de acueducto", entidad: "Veolia", dias: 15 },
  { nombre: "Conexión de gas natural", entidad: "Vanti", dias: 15 },
  { nombre: "Autorización de ocupación del inmueble", entidad: "Interior y Seguridad", dias: 15 },
];

const tramitesEn: Tramite[] = [
  { nombre: "Land-use concept", entidad: "Territorial Planning", dias: 15 },
  { nombre: "Building line certificate", entidad: "Territorial Planning", dias: 15 },
  { nombre: "Art. 73 compliance: road system and utilities", entidad: "Territorial Planning", dias: 15 },
  { nombre: "Water and sewer availability", entidad: "Veolia", dias: 45 },
  { nombre: "Natural gas availability", entidad: "Vanti", dias: 5 },
  { nombre: "Lot merger or boundary correction", entidad: "Cadastre Office", dias: 32 },
  { nombre: "Urban development and building permit", entidad: "Urban Curator's Office 2", dias: 45 },
  { nombre: "Urban delineation tax", entidad: "Treasury", dias: 1 },
  { nombre: "Public space intervention permit", entidad: "Territorial Planning", dias: 15 },
  { nombre: "Condominium (horizontal property) approval", entidad: "Urban Curator's Office 2", dias: 15, opcional: true },
  { nombre: "Housing sale registration", entidad: "Territorial Infrastructure", dias: 30 },
  { nombre: "Socioeconomic stratum certificate", entidad: "Territorial Planning", dias: 15 },
  { nombre: "Stratum claim", entidad: "Territorial Planning", dias: 15, opcional: true },
  { nombre: "Water service connection", entidad: "Veolia", dias: 15 },
  { nombre: "Natural gas connection", entidad: "Vanti", dias: 15 },
  { nombre: "Building occupancy authorization", entidad: "Interior and Security", dias: 15 },
];

export const es = {
  barra: { idioma: "Idioma", tema: "Cambiar tema" },
  nav: {
    inicio: "Inicio",
    comoFunciona: "Cómo funciona",
    ruta: "Ruta de construcción",
    preguntas: "Preguntas",
    ingresar: "Ingresar",
    crearCuenta: "Crear cuenta",
    menu: "Menú",
    cerrar: "Cerrar",
  },
  hero: {
    etiqueta: "Alcaldía Mayor de Tunja",
    titulo: "Ventanilla Única de Construcción",
    subtitulo:
      "Radica y sigue en línea los trámites para construir en Tunja, en un solo lugar y sin filas.",
    principal: "Iniciar un trámite",
    secundario: "Ver la ruta de construcción",
    cifras: [
      { valor: "16", texto: "trámites en una sola ruta" },
      { valor: "192 → 47", texto: "días hábiles: meta de reducción" },
      { valor: "24/7", texto: "radicación en línea" },
    ],
  },
  como: {
    etiqueta: "Cómo funciona",
    titulo: "Tu trámite en cuatro pasos",
    pasos: [
      { titulo: "Crea tu cuenta", texto: "Regístrate como persona natural o jurídica con tu cédula o NIT." },
      { titulo: "Inicia la ruta", texto: "Elige la Ruta de Construcción y el sistema te guía trámite por trámite." },
      { titulo: "Adjunta documentos", texto: "Carga los requisitos de cada paso en PDF desde cualquier lugar." },
      { titulo: "Sigue el avance", texto: "Consulta el estado y corrige en línea si te devuelven algo." },
    ],
  },
  ruta: {
    etiqueta: "Ruta de construcción",
    titulo: "16 trámites, una sola ventanilla",
    texto:
      "Las entidades de la ruta atienden tu solicitud desde la VUC. Los tiempos son los máximos de respuesta en días hábiles.",
    dias: "días hábiles",
    dia: "día hábil",
    opcional: "Opcional",
    tramites: tramitesEs,
  },
  aliados: { titulo: "Entidades que participan en la ruta" },
  preguntas: {
    etiqueta: "Preguntas frecuentes",
    titulo: "Resolvemos tus dudas",
    items: [
      {
        p: "¿Quién puede usar la VUC?",
        r: "Cualquier persona natural o jurídica que adelante un proyecto de construcción en Tunja: propietarios, constructores, arquitectos e ingenieros.",
      },
      {
        p: "¿Necesito ir presencialmente a alguna oficina?",
        r: "No. La radicación, la carga de documentos y el seguimiento se hacen en línea. Solo si una entidad lo exige te avisaremos de una visita técnica.",
      },
      {
        p: "¿Qué pasa si me devuelven un documento?",
        r: "Verás la observación del funcionario en tu panel, corriges el documento y lo reenvías desde el mismo trámite, sin empezar de nuevo.",
      },
      {
        p: "¿Cómo protegen mis datos?",
        r: "La información se trata conforme a la Ley 1581 de 2012 de protección de datos personales y solo la ven las entidades que atienden tu trámite.",
      },
    ],
  },
  llamado: {
    titulo: "¿Listo para construir en Tunja?",
    texto: "Crea tu cuenta y radica tu primer trámite hoy.",
    principal: "Crear cuenta",
    secundario: "Ya tengo cuenta",
  },
  pie: {
    descripcion:
      "Ventanilla Única de Construcción: los trámites del sector construcción de Tunja en un solo lugar.",
    atencion: "Atención al ciudadano",
    direccion: "Dirección",
    direccionValor: "Calle 19 # 9-95, Edificio Municipal, Tunja, Boyacá",
    horario: "Horario",
    horarioValor: "Lunes a jueves de 8:00 a. m. a 12:00 m. y de 2:00 a 6:00 p. m. · Viernes de 7:00 a. m. a 3:00 p. m.",
    contacto: "Contacto",
    conmutador: "Conmutador",
    lineaGratuita: "Línea de atención",
    correo: "Correo institucional",
    notificaciones: "Notificaciones judiciales",
    enlaces: "Enlaces",
    sitioAlcaldia: "Sitio web de la Alcaldía",
    portalEstado: "Portal del Estado colombiano",
    derechos: "Alcaldía Mayor de Tunja. Todos los derechos reservados.",
  },
  ingreso: {
    titulo: "Ingresar",
    subtitulo: "Accede con tu cédula o NIT",
    identificador: "Cédula o NIT",
    clave: "Contraseña",
    entrar: "Entrar",
    registrate: "¿No tienes cuenta? Regístrate",
    olvidaste: "¿Olvidaste tu contraseña?",
    errorConexion: "Error de conexión. Intenta de nuevo.",
    bienvenida: "¡Bienvenida",
    bienvenido: "¡Bienvenido",
    panelTitulo: "Ventanilla Única de Construcción",
    panelTexto: "Gestión eficiente de trámites de construcción en una sola plataforma.",
    seguro: "Acceso seguro y cifrado",
    disponible: "Alta disponibilidad",
  },
};

export type Textos = typeof es;

export const en: Textos = {
  barra: { idioma: "Language", tema: "Toggle theme" },
  nav: {
    inicio: "Home",
    comoFunciona: "How it works",
    ruta: "Building route",
    preguntas: "FAQ",
    ingresar: "Sign in",
    crearCuenta: "Sign up",
    menu: "Menu",
    cerrar: "Close",
  },
  hero: {
    etiqueta: "Mayor's Office of Tunja",
    titulo: "One-Stop Building Permit Office",
    subtitulo:
      "File and track the permits you need to build in Tunja online, in one place and without lines.",
    principal: "Start a procedure",
    secundario: "See the building route",
    cifras: [
      { valor: "16", texto: "procedures in a single route" },
      { valor: "192 → 47", texto: "business days: reduction goal" },
      { valor: "24/7", texto: "online filing" },
    ],
  },
  como: {
    etiqueta: "How it works",
    titulo: "Your procedure in four steps",
    pasos: [
      { titulo: "Create your account", texto: "Sign up as an individual or a company with your ID or tax number (NIT)." },
      { titulo: "Start the route", texto: "Choose the Building Route and the system guides you procedure by procedure." },
      { titulo: "Upload documents", texto: "Upload each step's requirements as PDF from anywhere." },
      { titulo: "Track progress", texto: "Check the status and fix anything returned to you online." },
    ],
  },
  ruta: {
    etiqueta: "Building route",
    titulo: "16 procedures, one single office",
    texto:
      "The route's agencies handle your request through the VUC. Times are maximum response times in business days.",
    dias: "business days",
    dia: "business day",
    opcional: "Optional",
    tramites: tramitesEn,
  },
  aliados: { titulo: "Agencies taking part in the route" },
  preguntas: {
    etiqueta: "FAQ",
    titulo: "We answer your questions",
    items: [
      {
        p: "Who can use the VUC?",
        r: "Any individual or company carrying out a building project in Tunja: owners, builders, architects and engineers.",
      },
      {
        p: "Do I need to visit an office in person?",
        r: "No. Filing, uploading documents and tracking are done online. If an agency requires a technical visit, we will let you know.",
      },
      {
        p: "What if a document is returned?",
        r: "You will see the officer's note on your dashboard, fix the document and resend it from the same procedure, without starting over.",
      },
      {
        p: "How is my data protected?",
        r: "Your information is handled under Colombia's Personal Data Protection Law (Law 1581 of 2012) and only the agencies handling your procedure can see it.",
      },
    ],
  },
  llamado: {
    titulo: "Ready to build in Tunja?",
    texto: "Create your account and file your first procedure today.",
    principal: "Sign up",
    secundario: "I already have an account",
  },
  pie: {
    descripcion:
      "One-Stop Building Permit Office: Tunja's building procedures in one place.",
    atencion: "Citizen service",
    direccion: "Address",
    direccionValor: "Calle 19 # 9-95, Municipal Building, Tunja, Boyacá, Colombia",
    horario: "Hours",
    horarioValor: "Monday to Thursday 8:00 a.m.–12:00 p.m. and 2:00–6:00 p.m. · Friday 7:00 a.m.–3:00 p.m.",
    contacto: "Contact",
    conmutador: "Switchboard",
    lineaGratuita: "Service line",
    correo: "Official email",
    notificaciones: "Legal notices",
    enlaces: "Links",
    sitioAlcaldia: "Mayor's Office website",
    portalEstado: "Colombian Government portal",
    derechos: "Mayor's Office of Tunja. All rights reserved.",
  },
  ingreso: {
    titulo: "Sign in",
    subtitulo: "Use your ID number (cédula) or NIT",
    identificador: "ID number or NIT",
    clave: "Password",
    entrar: "Sign in",
    registrate: "Don't have an account? Sign up",
    olvidaste: "Forgot your password?",
    errorConexion: "Connection error. Please try again.",
    bienvenida: "Welcome",
    bienvenido: "Welcome",
    panelTitulo: "One-Stop Building Permit Office",
    panelTexto: "Efficient management of building permits on a single platform.",
    seguro: "Secure, encrypted access",
    disponible: "High availability",
  },
};
